import { Component, OnInit, HostBinding } from '@angular/core';


import * as type from '../../../shared/action.event';
import { slideToRight } from '../../../shared/animations.collections';
import { EventListenerService } from '../../../services/close-listenenr.service';


@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['../nav-menu.css'],
  animations: [slideToRight()]
})
export class SettingComponent implements OnInit {
  @HostBinding('@slideToRight') ani;
  title = "SETTINGS"
  constructor(private closeService: EventListenerService) {}

  ngOnInit() {}

  closeSetting() {
    this.closeService.closeEvent(type.SETTING_PAGE);
  }
}
